import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/navbar/Navbar2";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import AxisTactical from "./pages/AxisTactical";
import Assessment from "./pages/Tier3Assessment";
import Assessment2 from "./pages/Tier2Assessment";
import Assessment1 from "./pages/Tier1Assessment";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Book from "./pages/Book";
import Join from "./pages/Join";
import Codex from "./pages/CodexPage";
import AppDownload from "./pages/AppDownload";
import BlogIndex from "./pages/blog/BlogIndex";
import BlogPost from "./pages/blog/BlogPost";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <div className="appShell">
      <Navbar />
      <main className="mainContent">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="AxisTactical" element={<AxisTactical />} />
          <Route path="assessment" element={<Assessment />} />
          <Route path="assessment2" element={<Assessment2 />} />
          <Route path="assessment1" element={<Assessment1 />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book" element={<Book />} />
          <Route path="/join" element={<Join />} />
          <Route path="/codex" element={<Codex />} />
          <Route path="/app" element={<AppDownload />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route component={NotFound} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
